import _                                  from 'underscore';
import React, { FC }                      from 'react';
import { Image, ImageProps, Placeholder } from 'semantic-ui-react';

//@ts-ignore
import CorvalHexHelpingLaptopUser          from '../../../_assets/images/theming/hex-characters/corval-hex-laptop-help.png';
//@ts-ignore
import CorvalHexBoardDiscussion            from '../../../_assets/images/theming/hex-characters/corval-hex-board-discussion.png';
//@ts-ignore
import CorvalHexPaperDiscussion            from '../../../_assets/images/theming/hex-characters/corval-hex-paper-discussion.png';
//@ts-ignore
import CorvalHexVideoCall                   from '../../../_assets/images/theming/hex-characters/corval-hex-video-call.png';
//@ts-ignore
import CorvalHexRingOblongLaptopDiscussion from '../../../_assets/images/theming/hex-characters/corval-hex-ring-oblong-laptop-discussion.png';
//@ts-ignore
import CorvalHexQuestionAnswer             from '../../../_assets/images/theming/hex-characters/corval-hex-question-answer.png';

import { StyledContainer, StyledContainerProps } from '../../containers';

export enum CHARACTER_VISUAL_AID {
	CORVAL_HEX_HELPING_USER,
	TEAM_PLANNING_BY_CHALKBOARD,
	TEAM_DISCUSSING_BY_PAPERS,
	CORVAL_HEX_INTERFACING_WITH_USERS,
	CORVAL_SHAPES_CONVERSING_WITH_LAPTOP,
	CORVAL_SHAPES_Q_AND_A
}

export interface CorvalCharacterVisualAidProps extends Omit<ImageProps, 'width' | 'height'> {
	type: CHARACTER_VISUAL_AID,
	margin?: StyledContainerProps['margin']
}

export const VISUAL_AID_CHARACTER_TYPES = {
	[ CHARACTER_VISUAL_AID.CORVAL_HEX_HELPING_USER ]:              {
		src:    CorvalHexHelpingLaptopUser,
		alt:    'Corval teal hex helping a dark blue user on a laptop',
		width:  390,
		height: 255,
	},
	[ CHARACTER_VISUAL_AID.TEAM_PLANNING_BY_CHALKBOARD ]:          {
		src:    CorvalHexBoardDiscussion,
		alt:    'Corval teal hex planning with other users by board',
		width:  561,
		height: 285,
	},
	[ CHARACTER_VISUAL_AID.TEAM_DISCUSSING_BY_PAPERS ]:            {
		src:    CorvalHexPaperDiscussion,
		alt:    'Corval teal hex planning with other users with paper',
		width:  500,
		height: 285,
	},
	[ CHARACTER_VISUAL_AID.CORVAL_HEX_INTERFACING_WITH_USERS ]:    {
		src:    CorvalHexVideoCall,
		alt:    'Corval teal hex interfacing with users in video chat',
		width:  296,
		height: 300,
	},
	[ CHARACTER_VISUAL_AID.CORVAL_SHAPES_CONVERSING_WITH_LAPTOP ]: {
		src:    CorvalHexRingOblongLaptopDiscussion,
		alt:    'Olive hex user talking to a dark blue oblong user by a laptop',
		width:  370,
		height: 300,
	},
	[ CHARACTER_VISUAL_AID.CORVAL_SHAPES_Q_AND_A ]:                {
		src:    CorvalHexQuestionAnswer,
		alt:    'Olive hex user talking to a dark blue oblong user by a laptop',
		width:  300,
		height: 300,
	},
}

const defaultProps: CorvalCharacterVisualAidProps = {
	type:   CHARACTER_VISUAL_AID.CORVAL_HEX_HELPING_USER,
	margin: null,
}

const CorvalCharacterVisualAid: FC<CorvalCharacterVisualAidProps> = ( props ) => {
	
	let { type, margin, ...imageProps } = props;
	
	// do we have a type?
	if( _.isEmpty( VISUAL_AID_CHARACTER_TYPES[ type ] ) ){
		return (
			<Placeholder style={ { height: 150, width: 150 } }>
				<Placeholder.Image/>
			</Placeholder>
		);
	}
	
	// construct image attributes
	let imgProps = {
		...VISUAL_AID_CHARACTER_TYPES[ type ],
		...imageProps
	}
	
	// Surround with styled container if margin needed
	let Tag      = margin ? StyledContainer : React.Fragment,
	    tagProps = margin ? { margin } : {};
	
	return (
		<Tag { ...tagProps }>
			<Image { ...imgProps }/>
		</Tag>
	);
};

CorvalCharacterVisualAid.defaultProps = defaultProps;

export { CorvalCharacterVisualAid }
